// File Uploader component - Now uses Multi-Step Wizard
import { UploadWizard } from '../wizard/UploadWizard';
import type { UploadFileGroup } from '../wizard/types';

interface UploadWizardState {
  files: File[];
  groups?: UploadFileGroup[];
  currentStep: string;
  fileType: string;
  fileStatus: string;
  beatstarsSellUrl?: string;
  beatstarsPrice?: string;
  collaborator?: string;
}

interface FileUploaderProps {
  onUploadComplete?: () => void;
  onCancel?: (state?: UploadWizardState) => void;
  initialFiles?: File[];
  restoredState?: Partial<UploadWizardState>;
}

export const FileUploader: React.FC<FileUploaderProps> = ({
  onUploadComplete,
  onCancel,
  initialFiles,
  restoredState,
}) => {
  return (
    <UploadWizard
      onUploadComplete={onUploadComplete}
      onCancel={onCancel}
      initialFiles={initialFiles}
      restoredState={restoredState}
    />
  );
};
